import Button from "@mui/material/Button";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";

export function IndicatorEditSuccessModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { open, setOpen } = props;

  const onClose = () => setOpen(false);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        Dados editados com sucesso!
      </DialogHeader>
      <DialogContent
        sx={{
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom>
          Os dados de indicadores foram editados com sucesso!
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
